import { createApp } from 'vue';
import { Quasar } from 'quasar';
import 'quasar/src/css/index.sass';
import App from './App.vue';
import router from './router';
import quasarConfig from './quasar';
import './assets/styles.css'; // Import the global CSS file

const app = createApp(App);

app.use(Quasar, quasarConfig);
app.use(router);
app.mount('#app');

// Set Theme Colors Based on Branding
const themeColors = {
    primary: '#c46c30', // Burnt orange
    secondary: '#e3a577', // Cream orange
    accent: '#f4c09c', // Light accent color
    background: '#1a1a1a', // Dark background
};

document.documentElement.style.setProperty('--primary-color', themeColors.primary);
document.documentElement.style.setProperty('--secondary-color', themeColors.secondary);
document.documentElement.style.setProperty('--accent-color', themeColors.accent);
document.documentElement.style.setProperty('--background-color', themeColors.background);
